module.exports = __webpack_public_path__ + "img/Spiegelbilder.3fcdfe79.jpg";